import React from 'react';
import BEM from '../bem';
import AskTigerSparkle from '../images/ask-tiger-sparkle.svg';
import { actions, useAppDispatch, useAppSelector } from 'redux-stores';

const { setTigerAgentPaneOpen } = actions;

const classes = BEM.with('TigerAgentButton');

export default function TigerAgentButton() {
  const dispatch = useAppDispatch();
  const tigerAgentPaneOpen = useAppSelector((state) => state.ui.tigerAgentPaneOpen);

  return (
    <button
      className={classes()}
      data-test-id="tiger-agent-button"
      onClick={() => dispatch(setTigerAgentPaneOpen(!tigerAgentPaneOpen))}
      title="Ask Tiger"
      type="button"
    >
      <span className={classes('icon-stack')}>
        <img src={AskTigerSparkle} alt="" aria-hidden className={classes('icon')} />
      </span>
      <span className={classes('label')}>Ask Tiger</span>
    </button>
  );
}
